import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIBox from 'UIComponents/layout/UIBox';
export const CONTROLLED_SIDEBAR_ID = 'controlled-sidebar';
export const UNCONTROLLED_SIDEBAR_ID = 'non-controlled-sidebar';
const Layout = styled(UIFlex).withConfig({
  displayName: "LayoutWithRightSidebar__Layout",
  componentId: "w05lbr-0"
})(["height:100%;"]); // overriding min-width: auto, meaning wide contents
// won't make width wider than container

const PageContents = styled(UIBox).withConfig({
  displayName: "LayoutWithRightSidebar__PageContents",
  componentId: "w05lbr-1"
})(["min-width:0;"]);
const LayoutWithRightSidebar = /*#__PURE__*/forwardRef(({
  children,
  sidebar,
  isControlled
}, ref) => {
  return /*#__PURE__*/_jsxs(Layout, {
    align: "stretch",
    id: isControlled ? CONTROLLED_SIDEBAR_ID : UNCONTROLLED_SIDEBAR_ID,
    children: [/*#__PURE__*/_jsx(PageContents, {
      ref: ref,
      grow: 1,
      children: children
    }), sidebar]
  });
});
LayoutWithRightSidebar.propTypes = {
  children: PropTypes.node.isRequired,
  sidebar: PropTypes.node,
  isControlled: PropTypes.bool.isRequired
};
export default LayoutWithRightSidebar;